import React from "react";

import { cn } from "@utils/utils";

import { Skeleton } from "@components/ui/skeleton";

interface BarChartLoaderProps {
  className?: string;
  orientation?: "horizontal" | "vertical";
  rows?: number;
}
const BarChartLoader: React.FC<BarChartLoaderProps> = ({
  className,
  orientation = "horizontal",
  rows = 5,
}) => {
  return (
    <div
      className={cn(
        "flex p-10 h-full ",
        className,
        orientation === "horizontal"
          ? " flex-col gap-y-3"
          : " flex-row gap-x-6 items-end h-full",
      )}
    >
      {orientation === "horizontal" ? (
        <>
          {Array.from({ length: rows }, (_, index) => (
            <Skeleton
              key={index}
              className={`w-${Math.floor(Math.random() * 6) + 1}/6 bg-secondary`}
              style={{ height: 100 / rows + "%" }}
            />
          ))}
        </>
      ) : (
        <>
          {Array.from({ length: rows }, (_, index: number) => (
            <Skeleton
              key={index}
              className="bg-secondary"
              style={{
                height: Math.random() * 80 + 20 + "%",
                width: 100 / rows + "%",
              }}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default BarChartLoader;
